// Hooks
import useTranslate from "../../../hooks/useTranslate";

// Images
import Empty from "../../../assets/images/glory/invite_empty.webp";
import EmptyBanger from "../../../assets/images/banger/empty_desc.webp";

import "./styles.sass";

const InviteFriendEmpty = () => {
  const t = useTranslate();
  const projectName = import.meta.env.VITE_APP_PROJECT_NAME;
  const Banner = projectName === "glory" ? Empty : EmptyBanger;
  return (
    <div className="InviteFriendEmpty">
      <span className="InviteFriendEmpty__title">{t("referral.nothing")}</span>
      <img className="InviteFriendEmpty__img" src={Banner} alt="empty" />
    </div>
  );
};

export default InviteFriendEmpty;
